import { Controller } from "@hotwired/stimulus";
import "daterangepicker";
import moment from "moment";

export default class DateRangeController extends Controller {
  connect() {
    let start = moment().subtract(6, "days");
    let end = moment();
    let defaultRange = this.data.get("tabName") || "Select Range";

    $(this.element).daterangepicker({
      startDate: start,
      endDate: end,
      maxDate: new Date(),
      ranges: {
        "Today": [moment(), moment()],
        "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
      }
    }, this.cb.bind(this, defaultRange));
    $(this.element).on("apply.daterangepicker", function (ev, picker) {
      let chosenLabel = picker.chosenLabel;
      let start_date = picker.startDate.format("YYYY-MM-DD");
      let end_date = picker.endDate.format("YYYY-MM-DD");
      let data_tab = chosenLabel;
      const data_url = new URL($(this.element).attr("data-url"), globalThis.location.origin);
      data_url.searchParams.set("tab_name", data_tab);
      data_url.searchParams.set("start_date", start_date);
      data_url.searchParams.set("end_date", end_date);

      $(this.element).closest(".card").find("turbo-frame").html("<div class=\"d-flex justify-content-center\">\n" +
        "  <div class=\"spinner-border\">\n" +
        "    <span class=\"visually-hidden\">Loading...</span>\n" +
        "  </div>\n" +
        "</div>");

      fetch(data_url, {
        method: "get",
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })
        .then(r => r.text())
        .then(html => {
          Turbo.renderStreamMessage(html);
        });
      $(this.element).find(".date-range-text").text(chosenLabel);
    }.bind(this));
  }

  cb(rangeName) {
    $(this.element).find(".date-range-text").text(rangeName);
  }
}
